<template>
  <b-card
    class="[&_span]:block"
    body-class="md:!pr-0"
  >
    <b-form
      ref="form"
      @reset="resetForm"
      @submit="submitForm"
    >
      <strong class="block text-[#333] font-semibold text-[20px] pb-[16px] border-b border-[#eee] md:mr-[20px]">
        Form Pendaftaran
      </strong>
      <section class="flex flex-col md:flex-row peer">
        <komlabs-registration-form
          ref="registrationForm"
          :fields.sync="fields"
          :banner.sync="banner"
        />
        <komlabs-registration-fields
          :fields.sync="fields"
          :banner.sync="banner"
          @openFieldPropsModal="openFieldPropsModal"
        />
      </section>
      <section
        class="pt-[20px] md:pr-[20px] flex justify-end flex-wrap gap-[8px] !border-t border-[#E2E2E2]
        peer-has-[:placeholder-shown]:[&>:last-child]:!bg-[#F4F4F4] peer-has-[:placeholder-shown]:[&>:last-child]:!border-[#E2E2E2]
        peer-has-[:placeholder-shown]:[&>:last-child]:!text-[#C2C2C2] peer-has-[:placeholder-shown]:[&>:last-child]:pointer-events-none"
      >
        <b-button
          type="reset"
          variant="outline-primary"
          class="grow basis-[100px] max-w-[200px]"
        >
          Reset
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          class="grow !flex gap-[8px] items-center justify-center basis-[100px] max-w-[200px] disabled:!bg-[#F4F4F4] disabled:pointer-events-none disabled:!border-[#E2E2E2] disabled:!text-[#C2C2C2]"
          :disabled="!fields.length || (!banner && !form) || loading"
        >
          <b-spinner
            v-if="loading"
            small
            variant="dark"
          />
          <span>Simpan</span>
        </b-button>
      </section>
    </b-form>
    <field-props-modal
      :data="editedField"
      @save="data => updatePropsField(data)"
    />
  </b-card>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import KomlabsRegistrationFields from './components/KomlabsRegistrationFields.vue'
import KomlabsRegistrationForm from './components/KomlabsRegistrationForm.vue'
import FieldPropsModal from './components/FieldPropsModal.vue'

export default {
  components: { KomlabsRegistrationForm, KomlabsRegistrationFields, FieldPropsModal },
  data() {
    return {
      form: null,
      banner: null,
      fields: [],
      loading: false,
      editedField: {
        type: 'text', label: '', placeholder: '', required: false,
      },
    }
  },
  mounted() {
    this.getForm()
  },
  methods: {
    prepareForm() {
      this.fields = this.form.questions.sort((a, b) => a.sort_order - b.sort_order)
      const inputs = ['title', 'overview', 'closing_statement']
      inputs.forEach(input => {
        const el = document.getElementById(input)
        el.value = this.form[input]
      })
      this.$refs.registrationForm.setBannerSource(this.form.header)
      this.$refs.registrationForm.setTextCount(this.form.overview, this.form.closing_statement)
    },
    async getForm() {
      try {
        this.loading = true
        const { data: { data } } = await newAxiosIns.get('/komclass/api/v1/komlabs/forms')
        this.form = data
        this.prepareForm()
      } catch (error) {
        if (error.response?.data?.meta?.message === 'komlabs form not found') return
        this.$toast_error({ message: 'Gagal memperoleh data formulir. Silakan coba lagi.' })
      } finally {
        this.loading = false
      }
    },
    openFieldPropsModal(field) {
      this.editedField = field
      this.$bvModal.show('field-props-modal')
    },
    updatePropsField(data) {
      this.fields = this.fields.map(field => (field.id === data.id ? data : field))
    },
    resetForm() {
      this.$refs.form.reset()
      this.$refs.registrationForm.resetForm()
    },
    async submitForm(e) {
      if (this.loading) return
      e.preventDefault()
      const form = new FormData(this.$refs.form)
      const invalidSubmission = ['title', 'overview', 'closing_statement'].some(input => !form.get(input))
      if (invalidSubmission || !this.fields.length || (!this.banner && !this.form)) return

      const newFields = this.fields.map(({ id, icon, ...rest }, idx) => ({ ...rest, sort_order: idx + 1 }))
      form.append('questions', JSON.stringify(newFields))
      form.delete('header')
      if (this.banner) form.set('header', this.banner)

      try {
        this.loading = true
        const method = this.form ? 'put' : 'post'
        await newAxiosIns[method]('/komclass/api/v1/komlabs/forms', form)
        this.$toast_success({ message: 'Form telah berhasil disimpan ke sistem.' })
      } catch (error) {
        this.$toast_error({ message: 'Data gagal disimpan. Silakan coba lagi.' })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
